@for( item of detailItems; track $index ) {
  <div class="contract-request-value">
    <span class="tw-font-bold">{{ item.label }}:</span> {{ item.value }}
  </div>
}
<div class="tw-pt-2">
  <div class="tw-grid tw-grid-flow-col">
    <div class="tw-font-bold tw-flex tw-items-center">Note For Lender:</div>
    <div class="tw-text-right">
      <button
        *ngIf="canEditContractRequests"
        type="button"
        mat-button
        color="primary"
        [disabled]="sending"
        (click)="edit()"
      >
        {{ contract_request.noteForLender ? 'Edit Note' : 'Add Note' }}
      </button>
    </div>
  </div>
  <span>{{ contract_request.noteForLender }}</span>
</div>
